import { AppKitNetwork } from '@reown/appkit/networks';

/**
 * Utility function to add custom RPC URL to a network
 * @param network - The original network object
 * @param rpcUrl - Custom RPC URL to use
 * @returns Network with custom RPC URL
 */
export function addCustomRpcUrl(
  network: AppKitNetwork,
  rpcUrl: string,
): AppKitNetwork {
  return {
    ...network,
    rpcUrls: { default: { ...network.rpcUrls.default, http: [rpcUrl] } },
  };
}
